import { useState } from "react";

export function Accordion({
  type = "single",
  collapsible = false,
  children,
  className = "",
}) {
  return <div className={className}>{children}</div>;
}

export function AccordionItem({ value, children, className = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div data-value={value} className={className}>
      {children && typeof children === "function"
        ? children({
            isOpen,
            setIsOpen,
          })
        : children}
    </div>
  );
}

export function AccordionTrigger({
  children,
  className = "",
  onClick,
  ...props
}) {
  return (
    <button
      className={`w-full text-left py-4 font-semibold hover:no-underline ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export function AccordionContent({ children, className = "" }) {
  return <div className={`py-4 ${className}`}>{children}</div>;
}
